module.exports = __webpack_public_path__ + "static/media/genisis7.0be8c530.jpg";